// import React from "react";
// import { useLocation } from "react-router-dom";
// import { Box, Card, Typography, Paper } from "@mui/material";
// import Header from "../components/Header";
// function CustomerView() {
//   const location = useLocation();
//   const { ticketDetails } = location.state || {};
//   console.log(ticketDetails);
//   return (
//     <Box
//       sx={{
//         minHeight: "100vh",
//         width: "100%",
//         backgroundColor: "#f0f2f5",
//         display: "flex",
//         flexDirection: "column",
//         overflow: "auto",
//       }}
//     >
//       <Header />
//       <Box
//         sx={{
//           flexGrow: 1,
//           display: "flex",
//           flexDirection: "column",
//           padding: 0,
//         }}
//       >
//         <Card
//           sx={{
//             backgroundColor: "rgba(0, 0, 0, 0)",
//             height: "auto",
//             boxShadow: "none",
//           }}
//         >
//           <Box
//             sx={{
//               paddingLeft: { xs: 2, sm: 10, md: 20 },
//               paddingRight: { xs: 2, sm: 10, md: 20 },
//               flexGrow: 1,
//             }}
//           >
//             <Box sx={{ padding: 3 }}>
//               <Typography variant="h4" gutterBottom>
//                 Ticket Details
//               </Typography>
//               {ticketDetails ? (
//                 <Paper sx={{ padding: 2 }}>
//                   <Typography variant="h6">
//                     Ticket Number: {ticketDetails.ticketNumber}
//                   </Typography>

//                   <Typography variant="body1">
//                     Customer Name: {ticketDetails.customerName}
//                   </Typography>
//                   <Typography variant="body1">
//                     Customer Email: {ticketDetails.customerMail}
//                   </Typography>
//                   <Typography variant="body1">
//                     Customer Contact: {ticketDetails.customerContact}
//                   </Typography>
//                 </Paper>
//               ) : (
//                 <Typography variant="body1">
//                   No ticket details available.
//                 </Typography>
//               )}
//             </Box>
//           </Box>
//         </Card>
//       </Box>
//     </Box>
//   );
// }

// export default CustomerView;
import React from "react";
import { useLocation } from "react-router-dom";
//import { Card, Typography, Paper } from "@mui/material";
import { Box,Paper, Card, CardContent, Typography, Grid, Stack } from "@mui/material";
import Header from "../components/Header";

function CustomerView() {
  const location = useLocation();
  const { ticketDetails } = location.state || {};
  //console.log(ticketDetails);

  // Helper function to format date-time
  const formatDateTime = (isoString) => {
    const date = new Date(isoString);
    return date.toLocaleString(); // Formats to locale-specific date and time string
  };

  // Define a helper function to create rows with static labels and dynamic values
  const createDetailRow = (label, value, highlight = false) => (
    <Box sx={{ display: "flex", mb: 1, textAlign: "left" }}>
      <Box sx={{ flex: 1 }}>
        <Typography
          variant="body1"
          sx={{
            fontWeight: "bold",
            color: highlight ? "primary.main" : "text.primary",
          }}
        >
          {label}:
        </Typography>
      </Box>
      <Box sx={{ flex: 2 }}>
        <Typography
          variant="body1"
          sx={{ color: highlight ? "primary.main" : "text.secondary" }}
          style={{width:'80%'}}
        >
         <p>{value}</p> 
        </Typography>
      </Box>
    </Box>
  );

  return (
    <Box
      sx={{
        minHeight: "100vh",
        width: "100%",
        backgroundColor: "#f0f2f5",
        display: "flex",
        flexDirection: "column",
        overflow: "auto",
      }}
    >
      <Header />
      <Box
        sx={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          padding: 0,
        }}
      >
        <Card sx={{  margin: "auto", padding: 3, borderRadius: 2, boxShadow: 3, width: "80%",maxWidth: "550px",mt: 4, mb: 4, }}>
          <Typography variant="h4" gutterBottom sx={{ textAlign: "center" }}>
            Ticket Details
          </Typography>
                    
          {ticketDetails ? (
            <Card sx={{ padding: { xs: 1, sm: 2 }, boxShadow: "none", border: "none" }}>
              <CardContent>
                <Stack spacing={1}>
                  {createDetailRow("Token", ticketDetails.token, true)}
                  {createDetailRow("Service Name", ticketDetails.serviceName)}
                  {createDetailRow("Issue Time", formatDateTime(ticketDetails.issueTime))}
                  {createDetailRow("Status", ticketDetails.status)}
                  {createDetailRow("Customer Name", ticketDetails.customerName)}
                  {createDetailRow("Customer Email", ticketDetails.customerEmail)}
                  {createDetailRow("Customer Contact", ticketDetails.customerContact)}
                </Stack>
              </CardContent>
            </Card>
          ) : (
            <Typography variant="body1" sx={{ textAlign: "center", padding: 2 }}>
              No ticket details available.
            </Typography>
          )}

        </Card>
      </Box>
    </Box>
  );
}

export default CustomerView;
